<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createInscripcionManual"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetInvitationsModalCreate.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
        <section class="m-the-modal-section-height-auto">
          <AtomTextAreaPrimary
            :class="{'a-input-primary a-input-danger': isRequired || invalidEmail}"
            v-model="inscripcion.email"
            :label="$t('mEditionAssetInvitationsModalCreate.inputs.email.label')"
            name="email"
            rows="5"
            :placeholder="$t('mEditionAssetInvitationsModalCreate.inputs.email.placeholder')"
            reference="email"
            type="text"
            :tooltip="$t('mEditionAssetInvitationsModalCreate.inputs.email.tooltip')"
            wrapperClass="display-flex-column"
            @blur="validateEmails"
          />
          <span v-show="isRequired">
            <small class="display-block text-color-danger">
              {{ this.$t("mEditionAssetInvitationsModalCreate.validation.email.required") }}
            </small>
          </span>
          <span v-show="invalidEmail">
            <small
              class="display-block text-color-danger"
              v-if="invalidEmails.length > 0"
            >
              {{ this.$t("mEditionAssetInvitationsModalCreate.validation.email.invalid") }}
            </small>
            <small
              class="display-block margin-left-medium margin-top-small text-color-danger"
              v-for="invalidEmail in invalidEmails.slice(0, 6)"
              :key="invalidEmail"
            >
             <i class="far fa-envelope">&nbsp;</i>{{ invalidEmail }}
            </small>
            <small
              v-if="invalidEmails.length > 6"
              class="display-block margin-top-small text-color-danger"
            >
             {{ this.$t("mEditionAssetInvitationsModalCreate.validation.email.others")}} {{invalidEmails.length-6}} {{this.$t("mEditionAssetInvitationsModalCreate.validation.email.more") }}
            </small>
          </span>
        </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetInvitationsModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetInvitationsModalCreate',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionAssetInvitationsModalCreate.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      inscripcion: {
        email: ''
      },

      invalidEmail: false,
      invalidEmails: [],
      isTouched: false,
      options: [],
      // eslint-disable-next-line no-useless-escape
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      showLoadingState: true
    }
  },

  computed: {
    isRequired () {
      return this.isTouched && this.inscripcion.email.length === 0
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.proyectoId = this.$route.params.id
  },

  methods: {
    onTouch () {
      this.isTouched = true
    },

    createInscripcionManual () {
      this.onTouch()
      if (!this.invalidEmail && !this.isRequired && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('inscripcion', 'createInscripcionManual', { proyecto: this.proyectoId, email: this.validateArray(this.inscripcion.email) }, [this.academiaId])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionAssetInvitationsModalCreate', 'createInscripcion', 'success')
            this.$modal.closeModal()
            this.$license.readAcademiaRecursosUsados()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mEditionAssetInvitationsModalCreate', 'createInscripcion', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    validateArray (array) {
      // convertir a array y eliminar espacios en blanco
      const emailsArray = array.split(',').map(email => email.trim())
      // eliminar duplicados
      const emailsArrayUnique = [...new Set(emailsArray)]
      // eliminar emails vacios
      const emailsArrayUniqueNotEmpty = emailsArrayUnique.filter(email => email !== '')
      return emailsArrayUniqueNotEmpty
    },

    validateEmails () {
      this.invalidEmails = []
      this.invalidEmail = false
      if (this.inscripcion.email.length !== 0) {
        const emailsArray = this.validateArray(this.inscripcion.email)
        const invalidEmails = []
        emailsArray.forEach((email) => {
          if (email !== '') {
            if (!this.reg.test(email.trim())) {
              this.invalidEmail = true
              invalidEmails.push(email.trim())
            }
          }
        })
        this.invalidEmails = invalidEmails
      }
    }
  }
}
</script>
